import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineIntegration, convertIntegrationFnToClass } from '@sentry/core';
var INTEGRATION_NAME = 'SessionTiming';
var _sessionTimingIntegration = function _sessionTimingIntegration() {
  var startTime = Date.now();
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent: function processEvent(event) {
      var now = Date.now();
      return _objectSpread(_objectSpread({}, event), {}, {
        extra: _objectSpread(_objectSpread({}, event.extra), {}, _defineProperty(_defineProperty(_defineProperty({}, 'session:start', startTime), 'session:duration', now - startTime), 'session:end', now))
      });
    }
  };
};
var sessionTimingIntegration = defineIntegration(_sessionTimingIntegration);

/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
var SessionTiming = convertIntegrationFnToClass(INTEGRATION_NAME, sessionTimingIntegration);
export { SessionTiming, sessionTimingIntegration };